import {
  restoreSupportIconState,
  setUnreadMessagesCount,
  setVisualGuidesCount,
  SupportState,
  ToggleSupportChat,
  ToggleSupportChatIcon,
  ToggleVisualGuidesIcon,
} from './actions';
import { createReducer, on } from '@ngrx/store';

export const initialState: SupportState = {
  chatOpen: false,
  chatIconOpen: false,
  unreadSupportMessagesCount: 0,
  visualGuidesOpen: false,
  visualGuidesCount: 0,
};
export const supportReducer = createReducer(
  initialState,
  on(ToggleSupportChat, (state, { force }) => ({
    ...state,
    chatOpen: typeof force === 'undefined' ? !state.chatOpen : force,
  })),
  on(ToggleVisualGuidesIcon, (state, { force }) => ({
    ...state,
    visualGuidesOpen:
      typeof force === 'undefined' ? !state.visualGuidesOpen : force,
  })),
  on(ToggleSupportChatIcon, (state, { force }) => ({
    ...state,
    chatIconOpen: typeof force === 'undefined' ? !state.chatIconOpen : force,
  })),
  on(restoreSupportIconState, (oldState, state) => ({
    ...oldState,
    chatIconOpen: state.chatIconOpen,
    chatOpen: state.chatOpen,
  })),
  on(setUnreadMessagesCount, (oldState, { count }) => ({
    ...oldState,
    unreadSupportMessagesCount: count,
  })),
  on(setVisualGuidesCount, (oldState, { count }) => ({
    ...oldState,
    visualGuidesCount: count,
  }))
);
